import React, { useState } from 'react';
import confetti from 'canvas-confetti';
import { CheckCircle } from 'lucide-react';



const CustomerFeedback = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    ticketId: '',
    email: '',
    rating: '',
    comments: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formDataToSend = new FormData();

    formDataToSend.append('ticket_id', formData.ticketId);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('rating', formData.rating);
    formDataToSend.append('comments', formData.comments);

    const response = await fetch(
      'https://indyanet.com/api/submit-feedback.php',
      {
        method: 'POST',
        body: formDataToSend,
      }
    );

    const result = await response.json();

    if (result.success) {

// 🎉 Grand Celebration
const duration = 7000;
const animationEnd = Date.now() + duration;

const defaults = {
  startVelocity: 35,
  spread: 360,
  ticks: 100,
  zIndex: 9999
};

const interval = setInterval(() => {

  const timeLeft = animationEnd - Date.now();

  if (timeLeft <= 0) {
    clearInterval(interval);
    return;
  }

  const particleCount = 25;

  confetti({
    ...defaults,
    particleCount,
    origin: {
      x: Math.random(),
      y: Math.random() * 0.2
    }
  });

}, 180);

setShowSuccess(true);

setTimeout(() => {
  window.location.href = "/";
}, 7000);

  setFormData({
    ticketId: '',
    email: '',
    rating: '',
    comments: '',
  });

} else {
  alert(result.message || 'Failed to submit feedback.');
}
  } catch (error) {
    console.error(error);
    alert('Something went wrong. Please try again.');
  }
};

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">
            Customer Feedback
          </h1>
          <p className="text-red-100">
            Help us improve our services by sharing your experience.
          </p>
        </div>
      </section>

      {/* Feedback Form */}
      <section className="py-12">
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-xl p-8">

          <form onSubmit={handleSubmit} className="space-y-6">

            <div>
              <label className="block text-sm font-medium mb-2">
                Ticket ID *
              </label>
              <input
                type="text"
                name="ticketId"
                value={formData.ticketId}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3"
                placeholder="Enter Ticket ID"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3"
                placeholder="Enter Email Address"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Service Rating *
              </label>

              <select
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3"
              >
                <option value="">Select Rating</option>
                <option value="5">⭐⭐⭐⭐⭐ Excellent</option>
                <option value="4">⭐⭐⭐⭐ Very Good</option>
                <option value="3">⭐⭐⭐ Good</option>
                <option value="2">⭐⭐ Fair</option>
                <option value="1">⭐ Poor</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Comments
              </label>

              <textarea
                name="comments"
                rows="5"
                value={formData.comments}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-3"
                placeholder="Share your feedback..."
              />
            </div>

            <button
              type="submit"
              className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition"
            >
              Submit Feedback
            </button>

          </form>

          {
  showSuccess && (

    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">

      <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-md text-center">

        <CheckCircle
  className="mx-auto text-green-500 mb-6"
  size={110}
/>

        <h2 className="text-4xl font-bold text-gray-800 mb-3">
          Thank You for Your Valuable Feedback!
        </h2>

        <p className="text-gray-600 text-lg leading-8">
          Your feedback has been submitted successfully.

We truly appreciate you taking the time to share your experience with us.
        </p>

        <p className="text-gray-500 mt-4">
          We sincerely appreciate your time and support.
          Your feedback helps us improve our services.
        </p>

        <button
          onClick={() => window.location.href = "/"}
          className="mt-8 bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition"
        >
          Back to Home
        </button>

      </div>

    </div>

  )
}

        </div>
      </section>
    </div>
  );
};

export default CustomerFeedback;